(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.nf-product').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const form = root.querySelector('[data-product-form]');
      const variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]');
      const hiddenId = root.querySelector('[data-variant-id]');
      const price = root.querySelector('[data-product-price]');
      const compare = root.querySelector('[data-product-compare]');
      const sku = root.querySelector('[data-product-sku]');
      const add = root.querySelector('[data-add-to-cart]');
      const addLabel = root.querySelector('[data-add-label]');
      const availableLabel = root.dataset.addLabel || 'Add to cart';
      const soldOutLabel = root.dataset.soldOutLabel || 'Sold out';
      const money = (cents) => new Intl.NumberFormat('en-PK', { style: 'currency', currency: root.dataset.currency }).format(cents / 100);
      const fit = root.querySelector('[data-mercie-fit]');
      const customVariant = variants.find((v) => String(v.id) === fit?.dataset.variantId);
      const trigger = fit?.querySelector('[data-fit-trigger]');
      const panel = fit?.querySelector('[data-fit-panel]');
      const fields = fit ? [...fit.querySelectorAll('[data-fit-measurement]')] : [];
      const summary = fit?.querySelector('[data-fit-summary]');
      const status = fit?.querySelector('[data-fit-status]');
      const total = fit?.querySelector('[data-fit-total]');
      const options = root.querySelector('.nf-product__options');
      const dynamic = root.querySelector('.nf-product__dynamic');
      const buy = root.querySelector('[data-custom-buy-now]');
      const notice = fit?.querySelector('[data-fit-notice]');
      let busy = false;
      const pending = () => Boolean(panel && !panel.hidden && !confirmed && fields.some((input) => input.value.trim() !== ''));
      const propertyFields = [...form.querySelectorAll('[data-fit-property]')];
      let selectedCustom = false;
      let confirmed = false;
      const baseVariant = () => {
        const selected = [...root.querySelectorAll('[data-option-value]:checked')].map((input) => input.value);
        return variants.find((v) => v.id !== customVariant?.id && v.options.every((value, index) => value === selected[index])) || (!selected.length ? variants.find((v) => v.id !== customVariant?.id) : null);
      };
      const update = () => {
        const variant = selectedCustom && confirmed ? customVariant : baseVariant();
        const blocked = pending() || !variant || !variant.available || busy;
        add.disabled = blocked;
        addLabel.textContent = busy ? 'Adding to cart...' : variant?.available ? availableLabel : soldOutLabel;
        if (notice) notice.hidden = !pending();
        if (buy) { buy.hidden = !(selectedCustom && confirmed); buy.disabled = blocked; }
        propertyFields.forEach((input) => { input.disabled = !(selectedCustom && confirmed); });
        if (options) {
          options.hidden = selectedCustom;
          options.querySelectorAll('[data-option-value]').forEach((input) => { input.disabled = selectedCustom; });
        }
        if (dynamic) dynamic.hidden = selectedCustom || blocked;
        if (variant) {
          hiddenId.value = variant.id;
          hiddenId.dispatchEvent(new Event('change', { bubbles: true }));
          price.textContent = money(variant.price);
          const onSale = Boolean(variant.compare_at_price && variant.compare_at_price > variant.price);
          price.classList.toggle('is-sale', onSale);
          if (compare) { compare.hidden = !onSale; if (onSale) compare.textContent = money(variant.compare_at_price); }
          if (sku) sku.textContent = variant.sku || '';
          const badge = root.querySelector('[data-sale-badge]');
          if (badge) { badge.hidden = !onSale; if (onSale) badge.textContent = '-' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%'; }
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
        if (fit) {
          fit.classList.toggle('is-confirmed', selectedCustom && confirmed);
          trigger.setAttribute('aria-expanded', String(!panel.hidden));
          status.textContent = selectedCustom && confirmed ? 'Measurements confirmed' : 'Optional customization';
          summary.hidden = !(selectedCustom && confirmed);
          total.textContent = money(customVariant.price);
        }
      };
      root.querySelectorAll('[data-option-value]').forEach((input) => input.addEventListener('change', update));
      if (fit && customVariant) {
        trigger.addEventListener('click', () => {
          panel.hidden = !panel.hidden;
          // Opening the editor does not opt the customer into paid customization.
          update();
          if (!panel.hidden) fields[0]?.focus();
        });
        fields.forEach((input) => input.addEventListener('input', () => { confirmed = false; selectedCustom = false; summary.hidden = true; update(); }));
        fit.querySelector('[data-fit-confirm]').addEventListener('click', () => {
          const invalid = fields.find((input) => !input.checkValidity() || !Number.isFinite(Number(input.value)) || Number(input.value) <= 0);
          if (invalid) { invalid.reportValidity(); invalid.focus(); return; }
          fields.forEach((input) => {
            const property = form.querySelector('[data-fit-property="' + input.dataset.fitMeasurement + '"]');
            property.value = Number(input.value) + ' in';
          });
          form.querySelector('[data-fit-property="Customization"]').value = 'Custom fit (+PKR 1,000 per pant)';
          selectedCustom = true;
          confirmed = true;
          summary.textContent = fields.map((input) => input.dataset.fitMeasurement + ' ' + Number(input.value) + ' in').join(' · ');
          panel.hidden = true;
          update();
          trigger.focus();
        });
        fit.querySelector('[data-fit-remove]').addEventListener('click', () => {
          selectedCustom = false;
          confirmed = false;
          panel.hidden = true;
          propertyFields.forEach((input) => { input.value = ''; });
          update();
          trigger.focus();
        });
      }
      const purchase = async (checkout = false) => {
        if (busy) return;
        if (pending()) {
          update();
          fields.find((input) => !input.value)?.focus();
          return;
        }
        const variant = selectedCustom && confirmed ? customVariant : baseVariant();
        if (!variant?.available) return;
        const quantityInput = form.querySelector('input[name="quantity"]');
        const count = Number(quantityInput?.value || 1);
        if (!Number.isInteger(count) || count < 1) {
          quantityInput?.reportValidity();
          quantityInput?.focus();
          return;
        }
        const properties = selectedCustom && confirmed
          ? Object.fromEntries(propertyFields.map((input) => [input.dataset.fitProperty, input.value])) : {};
        busy = true;
        update();
        const error = root.querySelector('[data-fit-error]');
        if (error) error.hidden = true;
        try {
          const route = window.Shopify?.routes?.root || '/';
          const sections = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } }));
          const response = await fetch(route + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: count, properties }], sections: [...new Set(sections)].slice(0, 5), sections_url: window.location.pathname })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this pant. Please try again.');
          if (checkout) { window.location.assign(route + 'checkout'); return; }
          const drawer = document.querySelector('cart-drawer');
          if (drawer && window.FoxTheme?.pubsub && result.sections && Object.values(result.sections).every(Boolean)) {
            const cartResponse = await fetch(route + 'cart.js', { headers: { Accept: 'application/json' } });
            if (!cartResponse.ok) throw new Error('Pant added. Please open your cart to review it.');
            const cart = await cartResponse.json();
            cart.sections = result.sections;
            window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
            document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: result } }));
            drawer.show(add);
          } else if (drawer) {
            await drawer.onCartRefresh({ detail: { open: true } });
          } else {
            window.location.assign(route + 'cart');
          }
        } catch (failure) {
          if (error) { error.textContent = failure.message || 'Unable to add this pant. Please try again.'; error.hidden = false; }
        } finally {
          busy = false;
          update();
        }
      };
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        purchase(false);
      }, true);
      buy?.addEventListener('click', () => purchase(true));
      const quantity = form.querySelector('input[name="quantity"]');
      root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
      root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1)) + 1; });
      const mobile = window.matchMedia('(max-width: 989px)');
      const syncTabs = () => root.querySelectorAll('[data-info-tab]').forEach((tab) => { tab.open = mobile.matches ? tab.dataset.openMobile === 'true' : tab.dataset.openDesktop === 'true'; });
      syncTabs();
      mobile.addEventListener('change', syncTabs);
      update();
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
